import { getCdnUrl } from '../../lib/cdnUrl';
import Link from 'next/link';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'tippy.js/dist/tippy.css';
import { IoIosArrowDropleftCircle, IoIosArrowDroprightCircle } from 'react-icons/io';
import { useRef } from 'react';

export const MintingCarousel = ({ mintings }) => {
  const [navigationPrevRef, navigationNextRef] = [useRef(null), useRef(null)];

  return (
    <section className='relative flex h-full w-full items-center bg-light-base px-4 py-16 dark:bg-jacarta-800 md:px-8 lg:min-h-[425px]'>
      <Swiper
        spaceBetween={50}
        slidesPerView={1}
        navigation={{
          prevEl: navigationPrevRef.current,
          nextEl: navigationNextRef.current,
        }}
        loop={true}
        modules={[Navigation]}
        className={'relative mx-auto h-full max-w-[85rem] select-none px-2'}
        style={{
          position: 'unset',
        }}
        onInit={(swiper) => {
          swiper.params.navigation.prevEl = navigationPrevRef.current;
          swiper.params.navigation.nextEl = navigationNextRef.current;
          swiper.navigation.init();
          swiper.navigation.update();
        }}
      >
        {mintings?.slice(0, 3).map((m, i) => (
          <SwiperSlide
            key={`mintingC-${m.id}-${i}`}
            className={'my-auto flex h-auto min-h-[265px] w-full flex-wrap'}
          >
            <div className='relative order-last flex w-full items-center px-2 lg:order-first lg:w-1/2 lg:px-8'>
              <div className='flex h-full w-full flex-col'>
                <div>
                  <div className='mb-3 flex w-fit flex-row space-x-3'>
                    <h2 className='!m-0 mb-4 w-full pt-1 font-display text-4xl font-bold text-jacarta-700 dark:text-white sm:text-4xl'>
                      {m?.collection?.name ?? m?.tokenName}
                    </h2>
                    <div className='relative flex items-center'>
                      <div
                        className={
                          'mr-2 inline-block rounded-full px-3 py-1 text-sm font-semibold text-white' +
                          (m.status === 'live'
                            ? ' bg-green'
                            : m.status === 'upcoming'
                            ? ' bg-blue'
                            : ' bg-red')
                        }
                      >
                        {m.status.toUpperCase()}
                      </div>
                    </div>
                  </div>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: m?.collection?.description ?? m?.description,
                    }}
                    className='w-full overflow-hidden text-base text-jacarta-400 [display:-webkit-box] [-webkit-box-orient:vertical] dark:text-jacarta-200'
                  />
                </div>
                <div className='mt-10 flex w-full flex-wrap items-center justify-end space-y-2 sm:space-y-0'>
                  <Link
                    href={
                      m?.mintType === 'nft'
                        ? m?.status !== 'ended'
                          ? `/nft/minting/${m?.collection?.address}`
                          : `/collection/${m?.collection?.chain}/${m?.collection?.address}`
                        : `/token/minting/${m?.tokenAddress}`
                    }
                  >
                    <a className='rounded-xl mb-2 inline-block w-full bg-accent py-3 px-8 text-center text-lg font-semibold text-white transition-all duration-300 hover:bg-accent-dark sm:mb-0 sm:w-fit'>
                      {m?.status !== 'ended'
                        ? m?.mintType === 'ise'
                          ? 'Go to ISE'
                          : 'Go to Mint'
                        : m?.mintType === 'ise'
                        ? 'Go to ISE'
                        : 'Explore Collection'}
                    </a>
                  </Link>
                </div>
              </div>
            </div>
            <div className='mb-4 w-full px-2 lg:mb-0 lg:w-1/2'>
              <div className='flex h-full flex-wrap items-center'>
                <div className='flex h-full w-full flex-wrap items-center justify-center'>
                  <div
                    style={{
                      backgroundImage: `url(${
                        m?.mintingPhotoPath || m?.collection?.coverPhotoPath || m?.bannerPhotoPath
                          ? getCdnUrl(
                              m?.mintingPhotoPath ??
                                m?.collection?.coverPhotoPath ??
                                m?.bannerPhotoPath,
                              'w100',
                              m?.collection?.updatedAt ?? m?.updatedAt,
                            )
                          : '/images/collections/_Bit5_U_Cover_1920x300.png'
                      })`,
                    }}
                    className='h-full w-full rounded-2lg bg-cover bg-center pt-[40%] lg:max-h-[300px]'
                  />
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
        <div className='absolute bottom-0 right-0 w-full px-4 md:right-2 md:px-8'>
          <div className='bottom-0 mx-auto w-full max-w-[85rem]'>
            <div className='relative w-full'>
              <button
                ref={navigationPrevRef}
                className='absolute bottom-4 right-10 flex h-fit w-fit cursor-pointer items-center'
              >
                <IoIosArrowDropleftCircle className='text-3xl text-jacarta-500 dark:text-jacarta-300' />
              </button>
              <button
                ref={navigationNextRef}
                className='absolute bottom-4 right-2 left-auto flex h-fit w-fit cursor-pointer items-center'
              >
                <IoIosArrowDroprightCircle className='text-3xl text-jacarta-500 dark:text-jacarta-300' />
              </button>
            </div>
          </div>
        </div>
      </Swiper>
    </section>
  );
};
